//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import portal from '~/net/portal'

export default {
    name: 'Help',
    components: {},
    data() {
        return {
            errorsignlog: '',
            errorsign: false,
            title: '',
            id: '',
            searchTip: [],
            tree: [],
            dataDetail: {},
            dataDetailnew: {}
        }
    },
    computed: {},
    watch: {
        $route(to, from) {
            this.asyncData()
        }
    },
    async asyncData(context) {
        const [resp2, resp3] = await Promise.all([
            portal.getHelpCategories({
                client: context.req
            }),
            portal.selectHelgetHelpKeywordKeyword({
                client: context.req
            })
        ])
        const data2 = resp2.data
        const data3 = resp3.data
        return {
            searchTip: data3,
            tree: data2
        }
    },
    created() {
        this.asyncData()
        this.tree = this.tree.map(_ => {
            return {
                title: _.name,
                expand: _.children ? _.children.some(x => x.id == this.dataDetail.categoryChildId) : false,
                // 问题答案内容的  二级类目id    x.id =  data1.categoryChildId  则 一级类目被打开
                children: _.children
            }
        })

        if (typeof this.$route.query.id != 'undefined') {
            this.id = this.$route.query.id

            this.tree.map(_ => {
                if (_.children) {
                    _.children.forEach(x => {
                        // 问题答案的 对应的2级类目 id 如果等于x.id 则   此二级类目被选中  this.dataDetail.categoryId
                        if (x.id == this.dataDetail.categoryChildId) {
                            return (x.title = x.name), (x.selected = true)
                        } else {
                            return (x.title = x.name)
                        }
                    })
                }
            })
        }
    },

    methods: {
        asyncData() {
            portal
                .getHelpContent({
                    query: {
                        id: this.$route.query.id
                    }
                })
                .then(res => {
                    const { code, data, message } = res
                    if (code == '0000') {
                        this.dataDetail = data
                        this.errorsign = true
                    } else {
                        this.errorsignlog = true
                    }
                })
                .catch(error => {
                    if ((error.code = '500')) {
                        this.errorsignlog = true
                    }
                })
        },
        renderContent(h, { root, node, data }) {
            return h(
                'span',
                {
                    style: {
                        display: 'inline-block',
                        width: '100%',
                        height: '40px'
                    },
                    class: {
                        'ivu-tree-span': true
                    }
                },
                [
                    h(
                        'span',
                        {
                            class: {
                                'ivu-span-hover': data.selected
                            }
                        },
                        data.title
                    ),
                    h(
                        'span',
                        {
                            class: {
                                'ivu-tree-arrow new-style': true
                            }
                        },
                        [
                            h('i', {
                                class: {
                                    'ivu-icon ivu-icon-ios-arrow-back': data.expand ? '' : true,
                                    'ivu-icon ivu-icon-ios-arrow-down': data.expand ? true : ''
                                },
                                on: {
                                    click: () => {
                                        const newArray = []
                                        this.tree.map(_ => {
                                            newArray.push(_.nodeKey)
                                        })
                                        if (newArray.includes(data.nodeKey)) {
                                            root.map(_ => (_.node.expand = false))
                                            if (data.expand) {
                                                data.expand = false
                                            } else {
                                                data.expand = true
                                            }
                                        }
                                        // data.expand ? data.expand = true : data.expand = false

                                        if (node.node.id) {
                                            this.$router.push('/help/Sec?id=' + node.node.id)
                                            //   <nuxt-link :to="{path:'/goods',query:{id:item.id}}">
                                        }
                                    }
                                }
                            })
                        ]
                    )
                ]
            )
        },

        searchBykeyword() {
            this.$router.push('/help/searchResult?title=' + this.title)
        },
        changeTitle(val) {
            this.title = val
            this.searchBykeyword()
        }
    }
}
